<div
  class="modal-trigger-button"
  [ngClass]="{ 'modal-trigger-button--disabled': isDisabled }"
  (click)="!isDisabled && handleClick()"
></div>
